module.exports = __webpack_public_path__ + "static/Corprate_Careers_22-2996ee750a7a44c4077ff14c3df10634.jpg";